import AlertDialog from '../components/common/AlertDialog';
import EmailChangeDialog from '../components/emailChange/EmailChangeDialog';

export default class MyAccountBloc {
  constructor({ userRepository, authRepository, dialogRepository }) {
    this.userRepository = userRepository;
    this.authRepository = authRepository;
    this.dialogRepository = dialogRepository;
  }

  async changePassword(oldPassword, newPassword) {
    await this.userRepository.changePassword(oldPassword, newPassword);
    this.dialogRepository.loadDialog(AlertDialog, {
      btnAction: () => this.dialogRepository.toggleDialog(false),
      btnText: 'Dismiss',
      message: 'Your password has been successfully changed. Please use your new password next time you log in.',
      title: 'Password Changed',
    });
  }

  async updateDetails(userDetails) {
    const updatedDetails = await this.userRepository.updateDetails(userDetails);
    this.userRepository.userDetails$.next({
      ...this.userRepository.userDetails$.getValue(),
      ...updatedDetails,
    });
    this.dialogRepository.loadDialog(AlertDialog, {
      btnAction: () => this.dialogRepository.toggleDialog(false),
      btnText: 'Dismiss',
      message: 'Your details have been successfully updated. If you have changed your email address this change will reflect on next login.',
      title: 'Details Updated',
    });
  }

  requestEmailChange() {
    this.dialogRepository.loadDialog(EmailChangeDialog, {
      onCancel: () => this.dialogRepository.toggleDialog(false),
    });
  }

  get userDetails$() {
    return this.userRepository.userDetails$;
  }
}
